import React from 'react';
import ReactDOM from 'react-dom';
import StdDeviationsContextMenu from '../components/StdDeviationsContextMenu';
import HistoGramContextMenu from '../components/HistoGramContextMenu';
import ContextMenuWrapper from '../components/common/ContextMenuWrapper.jsx';
import AnnotationContextMenu from '../components/AnnotationContextMenu';
import RulerContextMenu from "../components/RulerContextMenu";

export const CONTEXT_MENU_WIDTH = 218;
class ContextMenuUtil {
        static show = (position, uniqueObject, cb, isFrom, Dyn) => {
            // To populate color picker
        var ele = document.getElementById('std-dev-picker-wrapper');
        if(!ele) {
            ele = document.createElement('div');
            ele.setAttribute("id", "std-dev-picker-wrapper");
            ele.setAttribute("class", 'tde-theme-' + Dyn.preferences.getTheme());
            document.body.appendChild(ele);
        }
        let activeComponent;
        switch(isFrom) {
            case Dyn.plotUtil.stdSettingsButtonId:
                activeComponent = StdDeviationsContextMenu;
                break;
            case Dyn.plotUtil.histogramContextMenuID:
                activeComponent = HistoGramContextMenu;
                break;
            case Dyn.plotUtil.annotateContextMenuID:
                activeComponent = AnnotationContextMenu;
                break;
            case Dyn.plotUtil.rulerContextMenuID:
                activeComponent = RulerContextMenu;
                break;
            default:
                activeComponent = ContextMenuWrapper;
        }

        const eleRoot = ReactDOM.createRoot(ele);
        // ContextMenuWrapper :  Only has global menu and Color Picker
        /* If we want to Add other Item we have to create a separate Component, Which needs
           to inherit ContextMenuWrapper */
        eleRoot.render(
            React.createElement(activeComponent, {
                handleClose: function() {
                    eleRoot?.unmount();
                    cb();
                    // to show the focus once menu closed
                    document.getElementById(isFrom)?.focus();
                },
                handleChange: function(code, name = null) {
                    // eleRoot?.unmount();
                    cb(code, name);
                },
                position: position,
                contextMenuWidth: CONTEXT_MENU_WIDTH,
                Dyn: Dyn,
                ...uniqueObject,
            })
        );
    }
}

export default ContextMenuUtil;
